import RequestStatus from '../store/schema/RequestStatus';
import { orchestrator } from 'satcheljs';
import {
    discardAgendaMailOption,
    setGetCalendarFolderServiceStatus,
} from 'owa-agenda-mail-option/lib/actions/internalActions';

export default orchestrator(discardAgendaMailOption, () => {
    // reset the request status to the initial value
    setGetCalendarFolderServiceStatus(RequestStatus.NotInitialized);
});
